/* eslint-disable no-unused-vars */
import themeConfig from '@themeConfig'
import swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2'

const useSweetAlert = () => {
  const sweetAlertOptions: SweetAlertOptions = {
    icon: 'warning',
    inputAttributes: {
      autocapitalize: 'off',
    },
    customClass: {
      actions: 'swal-actions',
      confirmButton: 'swal-confirm-button',
    },
    reverseButtons: true,
    cancelButtonText: 'Cancelar',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showCancelButton: true,
    focusConfirm: false,
    focusDeny: false,
    focusCancel: false,
  }

  const getBtnConfirmColor = (type?: string): string => {
    switch (type) {
      case 'success':
        return themeConfig.themes.light.success
      case 'info':
        return themeConfig.themes.light.info
      case 'warning':
        return themeConfig.themes.light.warning
      case 'secondary':
        return themeConfig.themes.light.secondary
      case 'primary':
        return themeConfig.themes.light.primary
      case 'danger':
        return themeConfig.themes.light.error
      case 'accent':
        return themeConfig.themes.light.accent
      default:
        return themeConfig.themes.light.error
    }
  }

  const showMessage = (
    title: string,
    text: any,
    icon: SweetAlertIcon,
    staticAlert = false,
    allowOutsideClick = true,
  ): Promise<any> => {
    let swalOpt: SweetAlertOptions = {
      showConfirmButton: true,
      width: 400,
      icon,
      title,
      html: text,
    }

    swalOpt =
      icon === 'success' && !staticAlert
        ? {
            ...swalOpt,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
            position: 'top-right',
          }
        : { ...swalOpt, heightAuto: true, allowOutsideClick, backdrop: true }

    return swal.fire({ ...swalOpt })
  }

  const confirm = (
    mensaje: string | HTMLElement,
    type?: string,
    confirmButtonText = 'Aceptar',
    cancelButtonText = 'Cancelar',
  ): Promise<any> => {
    return swal.fire({
      title: 'Advertencia',
      html: mensaje,
      icon: 'warning',
      focusConfirm: false,
      focusDeny: false,
      focusCancel: false,
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      confirmButtonColor: getBtnConfirmColor(type),
      // cancelButtonColor: getBtnConfirmColor('danger'),
      customClass: {
        cancelButton: 'swal-cancel-btn',
      },
      reverseButtons: true,
    })
  }

  const showPrompt = (
    input: SweetAlertOptions['input'],
    title: string,
    text: string | HTMLElement,
    confirmButtonText: string,
    type?: string,
    cancelButtonText?: string,
  ) => {
    return swal.fire<string>({
      ...sweetAlertOptions,
      title,
      html: text,
      input,
      inputPlaceholder: 'Ingrese la observación',
      confirmButtonColor: getBtnConfirmColor(type),
      customClass: {
        cancelButton: 'swal-cancel-btn',
      },
      confirmButtonText,
      cancelButtonText: cancelButtonText ? cancelButtonText : 'Cancelar',
      inputValidator: value =>
        new Promise(resolve => {
          if (value) {
            resolve(null)
          } else {
            resolve('Ingrese la observación')
          }
        }),
    })
  }

  const launchError = (message: string) => {
    return swal.fire({
      icon: 'error',
      title: 'Error',
      width: 400,
      heightAuto: true,
      customClass: { popup: 'animated tada' },
      text: message,
    })
  }

  return {
    showMessage,
    confirm,
    showPrompt,
    launchError,
  }
}

export default useSweetAlert
